<template>
  <div>
    <div
      class="bg-white p-3 rounded my-2"
      v-for="(anuncio, index) in lista"
      :key="index"
    >
      <div class="row">
        <div class="col-md-6">
          <div class="label">Título Banner</div>
          <div class="value">{{ anuncio.titulo }}</div>
        </div>
        <div class="col-md-2">
          <div class="label">Data de Inicio</div>
          <div class="value">{{ anuncio.dtInicio | formataData }}</div>
        </div>
        <div class="col-md-3">
          <div class="label">Data de Encerramento</div>
          <div class="value">{{ anuncio.dtFim | formataData }}</div>
        </div>
        <div class="col-md-1">
          <button
            class="btn btn-link"
            data-toggle="modal"
            data-target="#modalRemover"
            @click="
              bannerId = anuncio.bannerId;
              desc = anuncio.titulo;
            "
          >
            <i class="material-icons">delete</i>
          </button>
        </div>
      </div>
    </div>
    <ModalRemover :descricao="desc" tipo="Banner" @click="remover" />
  </div>
</template>
<script>
import ModalRemover from "@/components/cadastro/ModalRemover";
export default {
  name: "Lista",
  components: { ModalRemover },
  props: {
    lista: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      bannerId: null,
      desc: null,
      loading: false,
    };
  },
  filters: {
    formataCPF(cpf) {
      //retira os caracteres indesejados...
      cpf = cpf.replace(/[^\d]/g, "");

      //realizar a formatação...
      return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    },
    formataData(dataObj) {
      const data = new Date(dataObj);
      const dataStr =
        ("0" + data.getDate()).slice(-2) +
        "/" +
        ("0" + (data.getMonth() + 1)).slice(-2) +
        "/" +
        data.getFullYear();
      return dataStr;
    },
  },
  methods: {
    remover(props) {
      if (props.props.resultado) {
        this.$http
          .post(
            `/api/Clube/CancelarBannerClubeVantagens?bannerId=${this.bannerId}`
          )
          .then((response) => {
            this.loading = false;
            if (response.status === 200) {
              document.querySelector("#closeModalClick").click();
              this.$toast.open({
                message: response.data.mensagem,
                type: "success",
                duration: 6000,
              });
              this.$emit("click", {
                props: {
                  carregarLista: true,
                },
              });
            }
          })
          .catch((error) => {
            document.querySelector("#closeModalClick").click();
            if (error.response.status === 401) {
              this.$router.push({ name: "login" });
            }
            console.error(error);
            this.$toast.open({
              message: "Erro ao cancelar o banner, tente novamente.",
              type: "error",
            });
            this.loading = false;
          });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.label {
  font-weight: 300;
  font-size: 14px;
  margin-bottom: 5px;
  line-height: 1.4;
}
.value {
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
  color: #000;
  line-height: 1.4;
}
.simple-value {
  font-size: 16px;
  text-transform: uppercase;
  color: #000;
  line-height: 1.4;
}
</style>
